module.exports = __webpack_public_path__ + "img/JalilKakaWais-BoniBanyadam.999aaf7a.jpg";